<template>
  <div class="catalog-wrapper fd-js-excludes">
    <EditHeader :closeShow="true" headerTitle="书刊目录" @closeHandler="closeCatalog">
      <div class="headers fd-js-excludes" v-if="isMobile">
        书刊目录
        <img src="@assets/imgs/close2x.png" alt="" @closeHandler="closeCatalog" class="fd-js-excludes" />
      </div>
    </EditHeader>

    <div class="catalog-content-wrapper fd-js-excludes" :class="{ mobile: isMobile, 'big-screen': isBigScreen }">
      <el-scrollbar v-if="!isMobile">
        <el-tree :data="catalogList" default-expand-all :expand-on-click-node="false" node-key="id" ref="tree" highlight-current :props="defaultProps" @node-click="handleNodeClick">
          <span class="custom-tree-node" slot-scope="{ node }">
            <div class="label-wrapper">
              <span class="slot-label">{{ node.label }}</span>
            </div>
          </span>
        </el-tree>
      </el-scrollbar>
      <el-tree v-else :data="catalogList" default-expand-all :expand-on-click-node="false" node-key="id" ref="tree" highlight-current :props="defaultProps" @node-click="handleNodeClick">
        <span class="custom-tree-node fd-js-excludes" slot-scope="{ node }">
          <div class="label-wrapper fd-js-excludes">
            <span class="slot-label fd-js-excludes">{{ node.label }}</span>
          </div>
        </span>
      </el-tree>
    </div>
  </div>
</template>
<script>
import EditHeader from './EditHeader.vue'
export default {
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  computed: {
    totalPage() {
      return this.$store.state.book.totalPage
    },
    isMobile() {
      return this.$store.state.book.isMobile
    },
    isBigScreen() {
      return this.$store.state.book.isBigScreen
    },
    catalogId() {
      return this.$store.state.config.bookObj.catalogId
    },
    catalogList() {
      return this.$store.state.config.bookObj.catalogList
    },
    isZoom() {
      return this.$store.state.book.isZoom
    }
  },
  methods: {
    handleNodeClick(data) {
      // 移动端 点击目录节点时隐藏左侧目录
      if (this.isMobile) {
        this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', false)
        this.$nextTick(() => {
          if (data.page > 0 && data.page <= this.totalPage) {
            $('#book').turn('disable', false)
            $('#book').turn('page', data.page)
            // 微信下则跳转至新的页面
            if (data.xiaoYangId) {
              sessionStorage.setItem('isShowDigitalArticleMenu_articleIndex', 1)
              window.location.href = window.location.origin + window.location.pathname + '#/digitalArticleMobile?id=' + data.xiaoYangId + '&type=book'
            }
          }
        })
      } else {
        if (this.isZoom) {
          this.$store.commit('book/UPDATE_IS_ZOOM', !this.isZoom)
          $('#book').turn('disable', false)
        }
        this.$nextTick(() => {
          if (data.page > 0 && data.page <= this.totalPage) {
            $('#book').turn('page', data.page)
            if (data.xiaoYangId) {
              this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_VIEW', true)
              this.$store.commit('book/DIGITAL_ARTICLE_ID', data.xiaoYangId)
            }
          }
        })
      }
    },
    closeCatalog() {
      this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', false)
    }
  },
  components: {
    EditHeader
  }
}
</script>
<style lang="scss">
.edit-wrapper {
  width: 300px !important;
  .catalog-wrapper {
    height: 100%;
    position: relative;
    .catalog-content-wrapper {
      position: absolute;
      top: 40px;
      bottom: 0px;
      width: 100%;
      .el-tree-node__content {
        line-height: 29px;
        min-height: 58px;
        height: auto !important;
        border-bottom: 1px solid #ececec;
        padding: 10px;
      }
      &.mobile {
        overflow-y: auto;
        background: #fff;
        .el-tree-node {
          white-space: pre-wrap !important;
        }
        .el-tree-node__content {
          // border-bottom: none;
          line-height: 29px;
          min-height: 58px;
          height: auto !important;
          padding: 10px;
        }
        .el-tree {
          background: none !important;
          color: #000;
          font-weight: normal !important;
          & > .el-tree-node {
            white-space: pre-wrap !important;
            & > .el-tree-node__content {
              font-size: 16px;
              font-weight: bolder;
            }
          }
        }
      }
      .el-scrollbar {
        height: 100%;
        width: 100%;
        .el-scrollbar__wrap {
          overflow-x: auto;
          height: calc(100% + 20px);
          .el-scrollbar__view {
            display: inline-block;
            white-space: pre-wrap;
            min-width: 100%;
          }
        }
      }
      /deep/.el-tree {
        font-size: 14px;
        .el-tree-node__expand-icon {
          display: none;
        }
        & > .el-tree-node {
          white-space: pre-wrap !important;
          & > .el-tree-node__content {
            font-size: 16px;
            font-weight: bolder;
            height: auto !important;
            margin: 5px 0 5px 0;
            border-bottom: 1px solid #ececec;
          }
          .el-tree-node__children {
            height: auto;
            margin: 0 0 5px 0;
            .el-tree-node__content {
              line-height: 29px;
              min-height: 58px;
              height: auto !important;
              border-bottom: 1px solid #ececec;
              padding: 10px;
            }
          }
        }
        .el-tree-node__label {
          text-indent: 20px;
        }
        .custom-tree-node {
          padding-left: 5px;
          display: inline-flex;
          justify-content: space-between;
          width: 100%;
          .label-wrapper {
            display: flex;
            align-items: center;
            width: 90%;
            margin: 0 auto;
            .slot-label {
              width: 100%;
              line-height: 24px;
              white-space: pre-wrap !important;
            }
          }
          // .slot-page {
          //   margin-right: 20px;
          // }
        }
      }
    }
  }
}
.headers {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-weight: bold;
  background: #ddd;
  color: #333;
  img {
    width: 26px;
    height: 26px;
    position: absolute;
    right: 6px;
    top: 6px;
  }
}
.el-tree-node {
  white-space: pre-wrap !important;
}
</style>
